import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DesktopLayoutComponent } from './desktop-layout/desktop-layout.component';
import { NotFoundComponent } from '@core/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: DesktopLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'tickets',
        loadChildren: () => import('../tickets/tickets.module').then(m => m.TicketsModule),
      },
      {
        path: 'orders',
        loadChildren: () => import('../orders/orders.module').then(m => m.OrdersModule),
      },
      {
        path: 'returns',
        loadChildren: () => import('../returns/returns.module').then(m => m.ReturnsModule),
      },
      {
        path: 'pickup-in-store',
        loadChildren: () =>
          import('../pickup-in-store/pickup-in-store.module').then(m => m.PickupInStoreModule),
      },

      {
        path: 'changelog',
        loadChildren: () =>
          import('common/libs/bitforce/modules/changelog/bitf-changelog.module').then(
            m => m.BitfChangelogModule
          ),
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DesktopRoutingModule {}
